'use client';

import { Button } from '@heroui/react';
import { motion } from 'framer-motion';
import Image from 'next/image';
import Link from 'next/link';

export default function Hero({
  title,
  subtitle,
  cta,
}: {
  title: string;
  subtitle: string;
  cta: string;
}) {
  return (
    <div className="hero-aurora w-full min-h-screen flex items-center overflow-hidden relative px-4 pt-24 pb-12 sm:pt-28">
      <div className="hero-aurora__spotlight" aria-hidden="true" />
      <Image
        src="/ai-consulting-hero.png"
        alt="Consulting team reviewing dashboards and process information"
        className="hero-aurora__image object-cover"
        fill
        priority
      />
      <motion.div
        className="hero-aurora__content text-white drop-shadow-lg"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
      >
        <p className="hero-eyebrow">Christoph Zeltner - AI Consulting</p>
        <h1 className="hero-title">{title}</h1>
        <p className="hero-subtitle">{subtitle}</p>
        <div className="hero-actions">
          <Button as={Link} href="#contact" color="primary" size="lg" radius="sm" className="font-semibold">
            {cta}
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
